import api from '../../../../services/api';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import PageContainer from '../../../../common/components/PageContainer';
import useAlerta from '../../../../common/components/useAlerta';
import AppSnackbar from '../../../../common/components/AppSnackbar';

function AlmoxarifadoEntrada() {
    const [item, setItem] = useState({});
    const { id } = useParams();
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const { register, handleSubmit, reset, setValue } = useForm();

    const onSubmit = async (data) => {
        const formData = {
            acao: "Entrada",
            ...data,
        };

        try {
            await api.put(`/almoxarifado/${id}/add`, formData);
            mostrarAlerta('Entrada realizada com sucesso!', 'success');
            setTimeout(() => {
                window.location.href = `/almoxarifado/${id}`;
            }, 1500);
        } catch (error) {
            mostrarAlerta('Erro ao realizar a entrada!', 'error');
        }
        setTimeout(fecharAlerta, 3000);
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/almoxarifado/${id}`);
                setItem(response.data);
                reset(response.data);
                const hoje = new Date().toISOString().split('T')[0];
                setValue("data", hoje);
            } catch (error) {
                console.error('Erro ao buscar o item:', error);
            }
        }

        fetchData();
    }, [id, reset, setValue]);

    return (
        <PageContainer sx={{ maxWidth: 700 }}>
            <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                    <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600 }}>
                        {item.nome}
                    </Typography>
                    {item.foto && (
                        <Box component="img" src={`data:image/jpeg;base64,${item.foto}`} alt="Item" sx={{ height: 40, borderRadius: 1 }} />
                    )}
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <TextField {...register("quantidade")} label="Quantidade" type="number" inputProps={{ step: '0.01', min: 0 }} required fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <TextField {...register("descricao")} label="Descrição" required fullWidth />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField {...register("data")} label="Data da entrada" type="date" InputLabelProps={{ shrink: true }} required fullWidth />
                    </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <Button type="submit" variant="contained" color="secondary" size="large" sx={{ px: 6 }}>
                        Realizar entrada
                    </Button>
                </Box>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default AlmoxarifadoEntrada;
